import React from 'react'

const IconeLivroAberto: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    {...props}
    fill="#000000"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <rect x="103.925" y="114.521" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <rect x="103.925" y="168.116" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <rect x="103.925" y="221.721" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <rect x="103.925" y="275.316" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <rect x="292.857" y="114.521" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <rect x="292.857" y="168.116" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <rect x="292.857" y="221.721" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <rect x="292.857" y="275.316" width="115.22" height="30.417" />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M460.143,83.597V57.643H301.046c-16.81,0-32.837,6.366-45.046,17.348c-12.208-10.983-28.236-17.348-45.046-17.348H51.857
          v25.954H0v330.919h210.954c16.81,0,32.837-6.366,45.046-17.349c12.209,10.983,28.236,17.349,45.046,17.349h26.043v39.84
          l43.54-24.355l43.54,24.355v-39.84H512V83.597H460.143z M210.954,384.1H30.417V114.014h21.44v248.593h159.097
          c9.819,0,19.154,3.97,25.986,10.746C230.107,380.13,220.773,384.1,210.954,384.1z M240.791,339.213
          c-9.147-4.539-19.34-7.022-29.837-7.022H82.274V114.014V88.06h128.68c11.829,0,22.941,5.774,29.837,15.263V339.213z
          M327.089,384.1h-26.043c-9.819,0-19.154-3.97-25.986-10.746c6.834-6.776,16.168-10.746,25.986-10.746h26.043V384.1z
          M383.752,402.491l-13.123-7.341l-13.123,7.341v-39.883h26.246V402.491z M327.089,332.082v0.109h-26.043
          c-10.497,0-20.69,2.483-29.837,7.022v-235.89c6.897-9.489,18.008-15.263,29.837-15.263h128.68v25.955v218.176h-15.556v-0.109
          H327.089z M481.583,384.1h-67.414v-21.493h45.973V114.014h21.44V384.1z"
        />
      </g>
    </g>
  </svg>
)

export default IconeLivroAberto
